<template>
  <div class="userMain">
    <!-- 搜索框 -->
    <SearchBar
      @search="fetchData"
      @opentitleForm="opentitleForm"
      :checkList="checkList"
    />

    <!-- 表单 -->
    <el-table
      class="table"
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="60" label="编号">
        <template slot-scope="scope">
          {{ pageSize * (pageIndex - 1) + (scope.$index + 1) }}
        </template>
      </el-table-column>

      <el-table-column label="标题" align="center">
        <template slot-scope="scope">
          {{ scope.row.title }}
        </template>
      </el-table-column>

      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          {{ statuList[scope.row.status - 1] }}
        </template>
      </el-table-column>

      <el-table-column label="图标" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 50px; height: 50px"
            :src="scope.row.icon"
            fit="fill"
          />
        </template>
      </el-table-column>

      <!-- <el-table-column class-name="status-col" label="更新用户" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.updateBy">{{ scope.row.updateBy.nickName }}</div>
        </template>
    </el-table-column>

    <el-table-column class-name="status-col" label="更新时间" align="center">
        <template slot-scope="scope">
          <div >{{ scope.row.updateTime }}</div>
        </template>
    </el-table-column> -->

      <el-table-column class-name="status-col" label="操作" align="center">
        <template slot-scope="scope">
          <div class="lastBtn">
            <el-button
              size="small"
              @click="editCell(scope.row)"
              type="text"
              v-if="roleList[path].includes('_Update')"
              >编辑标题</el-button
            >
            <el-button
              size="small"
              @click="delCell(scope.row)"
              type="text"
              v-if="roleList[path].includes('_Delete')"
              >删除标题</el-button
            >
          </div>
          <div class="lastBtn">
            <el-button
              size="small"
              @click="editContent(scope.row)"
              type="text"
              v-if="roleList[path].includes('_Edit_Content')"
              >编辑内容</el-button
            >
            <el-button
              size="small"
              @click="addContent(scope.row.helpId)"
              v-if="roleList[path].includes('_Add_Content')"
              type="text"
              >新增内容</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <!-- <Pagination ref="Pagination" /> -->

    <!-- 标题对话框 -->
    <titleForm ref="titleForm" @fetchData="fetchData" />

    <!-- 内容对话框 -->
    <contentForm ref="contentForm" @fetchData="fetchData" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getHelpApi, delHelpApi, getHelpContentApi } from '@/api/newsApi.js';
const titleForm = () => import('./components/titleForm'); // 标题对话框
const contentForm = () => import('./components/contentForm'); // 内容对话框
import SearchBar from './components/searchBar'; // 搜索框
export default {
  name: 'Message',
  components: {
    titleForm,
    contentForm,
    SearchBar,
  },
  data() {
    return {
      list: [],
      listLoading: false,
      editShow: true,
      // size和index用于计算编号
      pageSize: '',
      pageIndex: '',
      path: '',
      statuList: ['编辑中', '已发布', '已删除'],
      checkList: [], // 选中的列表
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    this.fetchData();
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },

  methods: {
    // 请求表单数据
    // searchBar会触发此方法
    async fetchData(obj = {}) {
      try {
        this.listLoading = true;
        // status ->  1.编辑中， 2.已发布， 3.已删除
        let res = await getHelpApi({
          ...obj,
        });
        if (res.code !== 200) return;
        this.listLoading = false;
        this.list = res.data;
      } catch (e) {
        window.console.log(e);
      }
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.helpId;
      });
    },
    opentitleForm() {
      this.$refs.titleForm.dialogFormVisible = true;
    },

    // 编辑标题
    editCell(row) {
      this.$refs.titleForm.form = {
        // 编辑表单
        title: row.title,
        status: row.status,
        icon: row.icon,
        helpId: row.helpId,
      };
      this.$refs.titleForm.statuName = this.statuList[row.status - 1];
      this.$refs.titleForm.titleName = '编辑';
      this.$refs.titleForm.dialogFormVisible = true;
    },

    // 删除标题
    async delCell(row) {
      try {
        if (row.status === 3) return this.$message.warning('已是删除状态');
        this.$confirm('删除标题会及其内容也删除，您确定还要删除吗？', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            let res = await delHelpApi(row.helpId);
            if (res.code !== 200) return;
            this.$message.success('删除成功！');
            this.fetchData();
          })
          .catch(() => {});
      } catch (e) {
        window.console.log(e);
      }
    },

    // 编辑内容
    async editContent(row) {
      try {
        // 获取内容
        await getHelpContentApi(row.helpId).then((res) => {
          if (res.code !== 200) return;
          // 设置内容
          let newList = res.data.map((item) => {
            return {
              answer: item.answer,
              question: item.question,
              contentId: item.contentId,
              status: item.status,
            };
          });
          this.$refs.contentForm.titleName = '编辑';
          this.$refs.contentForm.form = {
            helpContent: newList,
            helpId: row.helpId,
            status: row.status,
          };
          this.$refs.contentForm.dialogFormVisible = true;
        });
      } catch (e) {
        window.console.log(e);
      }
    },

    addContent(id) {
      this.$refs.contentForm.titleName = '新增';
      //初始化数据
      this.$refs.contentForm.form = {
        status: '',
        helpId: id,
        helpContent: [{ question: '', answer: '答:', status: '' }],
      };
      this.$refs.contentForm.dialogFormVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
.userMain {
  position: relative;
}

.table {
  height: 75vh;
  overflow: auto;
  // white-space: nowrap;
  // overflow-x: scroll;
}

/deep/ .el-checkbox__input {
  margin-left: 10px;
}

// 隐藏选择框的文字
/deep/ .el-checkbox__label {
  display: none;
}

.lastBtn {
  margin-top: 10px;
}
</style>
